// removed by extract-text-webpack-plugin
module.exports = {"radioButton":"waEDbq7sMOnpymAmGu70Y","table":"_2SvyFlehZf-5ap80auRI4p"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/patientPages/wellChildCheck/PhysicalExam.scss
// module id = 182
// module chunks = 0